let selectGenderValue;

document.addEventListener("DOMContentLoaded", function () { 
  let genderList = ['Male', 'Female', 'Prefer Not To Say']

  getGender();

  function getGender() {
    $('.no-profile-h5 .gender-list').empty();
    genderList.forEach((item,index) => {
      $('.no-profile-h5 .gender-list').append(`
        <div onclick="selectGender(${index})" class="gender-item">
        ${item}
          <img src="https://cdn.heychic.net/material/model/selectTrue-d1f8ffb9c185982.png" class="gender-check"/>
        </div>
        `)
    })
  }
});

function selectGender(index) { 
  selectGenderValue = index;
  console.log(selectGenderValue,'index===');
  // 1. 先隐藏所有的勾选图标 (重置状态)
  $('.no-profile-h5 .gender-check').hide();
  
  // 2. 只显示当前选中项的勾选图标
  $('.no-profile-h5 .gender-list .gender-item').eq(index).find('.gender-check').show();
}


function goEdit() {
  $(".have-profile").hide();
  $(".no-profile").show();
} 

function goSave() {
  let firstName_info = document.getElementById("edit-first-name").value;
  let lastName_info = document.getElementById("edit-last-name").value;
  let phone_info = document.getElementById("edit-phone").value;
  let birthday_info = document.getElementById("edit-birthday").value;
  const radios = document.querySelectorAll('input[name="gender"]');

  if(!isLikelyPhone(phone_info)){
    showToastTips('Phone number is invalid','error');
    return;
  }

  let selectedValue = "";
  for (const radio of radios) {
    if (radio.checked) {
      selectedValue = radio.value;
      break;
    }
  }

  var proNum = document.querySelector(".profile-content .iti__selected-flag");
  var proNumCode = document.querySelector(
    ".profile-content .iti__selected-dial-code"
  ).innerText;

  if (proNum) {
    var proCountry = proNum.getAttribute("aria-activedescendant"); //国家编码
    if(proCountry.includes('-preferred')){
      proCountry = proCountry.replace('-preferred','').slice(-2);
    }else{
      proCountry = proCountry.slice(-2);
    }
    localStorage.setItem("proCountry", proCountry);
  }

  var editInfo = {
    shop_id: shopIdAuth,
    first_name: firstName_info,
    last_name: lastName_info,
    phone_code: proNumCode,
    phone_country: proCountry,
    phone_number: phone_info,
    birthday: birthday_info,
    gender: window.innerWidth > 750 ? selectedValue : selectGenderValue >=0 ? selectGenderValue + 1 : '',
  };

  var profileEdit = `${heychic_api}/web/customer/saveCustomerInfo`;
  fetch(profileEdit, {
    method: "POST", // 请求方法
    headers: {
      "Content-Type": "application/json", // 请求头，指明请求体格式为 JSON
      Authorization: authorization,
      "X-Shop-Id": shopIdAuth,
    },
    body: JSON.stringify(editInfo), // 请求体，转为 JSON 字符串
  })
    .then((response) => response.json()) // 处理响应并将其解析为 JSON
    .then((data) => {
      if (data.code == 200) {
        if(window.innerWidth > 750){
          $(".have-profile").show();
        }else{
          $('.no-profile-h5 .form-field').hide();
        }
        $(".no-profile").hide();
        getProfile();
      }else{
        showToastTips(`${data.message}`, 'error');
      }
    }) // 处理返回的数据
    .catch((error) => console.error("Error:", error)); // 错误处理
}

var getShopIds = localStorage.getItem("shopId");

if(window.location.pathname == "/pages/profile-info" || window.innerWidth > 750){
    getProfile();
    if(localStorage.getItem("subscribed") == 1 && !localStorage.getItem("callInterface")){
      getSubscribed();
      localStorage.setItem("callInterface",true);
    }
}


function closePoints(){
  $('.profile-tips').hide();
}

// 日期改为横线格式
function formatBirthdayEdit(dateStr) {
  if (dateStr.includes('/')) {
      var parts = dateStr.split('/'); // 按 `/` 拆分
      if (parts.length === 3) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`; // 转换成 YYYY-MM-DD
      }
  }
  return dateStr;
}


// 个人信息详情
function getProfile() {
  var paramsInfo = {
    shop_id: shopIdAuth,
    customer_id: ShopifyAnalytics.meta.page.customerId,
  };

  // 使用 URLSearchParams 对象来处理参数
  var urlParams = new URLSearchParams(paramsInfo);

  var profileInfo = `${heychic_api}/web/customer/customerInfo`;
  fetchRequest(profileInfo, "GET")
    .then((data) => {
      if (data.code == 200 && data.data) {
        const customerEmail = window.customerEmail;
        const editIconInfo = "<img src='https://cdn.heychic.net/material/review/editIcon-e5aa450443b00db.png' class='icon-edit' alt='icon-edit' onclick='goEdit()'>"
        // 默认头像'
        if(data.data?.head_image){
          $('.logoHeader_person').html(`<img src='${data.data?.head_image}' alt=""/>`);
        }else{
           $('.logoHeader_person').html(`
          <div class="staticImg">
          ${data.data.email ? data.data.email.charAt(0) : customerEmail ? customerEmail.charAt(0) : ''}
          </div>`);
        }
       
        $(".info-first-name").text(data.data.first_name);
        $(".info-last-name").text(data.data.last_name);
        $(".info-phone").text(
          data.data.phone_code + data.data.phone_number
        );
        $(".info-birthday").text(data.data.birthday);
        $(".info-gender").text(
          data.data.gender == 1
            ? "Male"
            : data.data.gender == 2
            ? "Female"
            : data.data.gender == 3 ? "Prefer Not To Say" :''
        );
        if(window.innerWidth > 750){
          if(data.data.first_name == '' || !data.data.first_name){
            $(".info-first-name").html(editIconInfo);
          }
          if(data.data.last_name == '' || !data.data.last_name){
            $(".info-last-name").html(editIconInfo);
          }

          if(data.data.phone_number == '' || !data.data.phone_number){
            $(".info-phone").html(editIconInfo);
          }
          if(data.data.gender == '' || !data.data.gender){
            $(".info-gender").html(editIconInfo);
          }
          if(data.data.birthday == '' || !data.data.birthday){
            $(".info-birthday").html(editIconInfo);
          }
        }
        

        if(data.data.first_name == '' || data.data.last_name == '' || data.data.phone_number == '' || data.data.gender == '' || data.data.birthday == ''){
          $('.profile-tips').css('display','flex');
        }else{
          $('.profile-tips').hide();
        }
        $(".info-email").text(data.data.email || customerEmail);
        $(".info-date").text(data.data.create_time);
        localStorage.setItem("proCountry", data.data.phone_country);
        localStorage.setItem("birthday", data.data.birthday);


        $("#edit-first-name").val(data.data.first_name);
        $("#edit-last-name").val(data.data.last_name);
        $("#edit-phone").val(
          // data.data.phone_code + data.data.phone_number || "-"
          data.data.phone_number || ""
        );
        $("#edit-birthday").val(formatBirthdayEdit(data.data.birthday) || "");

        const radioSelect = document.querySelectorAll('input[name="gender"]');

        // 遍历所有单选按钮
        radioSelect.forEach((radio) => {
          // 比较每个按钮的值与数据中的性别值
          if (radio.value == data.data.gender) {
            // 如果匹配，设置该按钮为选中状态
            radio.checked = true;
          }
        });

        let targetIndex = -1;
        
        if (data.data.gender == 1) {
            targetIndex = 0; // Male
        } else if (data.data.gender == 2) {
            targetIndex = 1; // Female
        } else if (data.data.gender == 3){
            targetIndex = 2; // Prefer Not To Say
        }

        if (targetIndex !== -1) {
            $(".no-profile-h5 .gender-item").eq(targetIndex).find('.gender-check').show();
        }
      }

      // if(data.code == 401){
      //   deleteAllCookies(); // 清除 Cookies
      //   window.location.href = "/account/logout"; // 跳转到登出页面
      // }
    })
    .catch((error) => console.error("Error fetching data:", error));
}

// 显示编辑信息
function showInfo(num){
  $('.profile-content .no-profile-h5').css("display", "flex");
  $(`.no-profile-h5 .form-field`).eq(num).show().siblings().hide();
}

// 关闭信息
function closeInfo(num){
  $(`.no-profile-h5 .form-field`).eq(num).hide();
  $('.profile-content .no-profile-h5').hide();
}

function getSubscribed() {
  const myHeaders = new Headers();
  myHeaders.append("X-Shop-Id", shopIdAuth);
  myHeaders.append("Authorization", authorization);
  myHeaders.append("Content-Type", "application/json");

  let subBody = {};

  if(window.location.pathname.includes('retail-store')){
    subBody = {
      subscribed: localStorage.getItem("subscribed"),
      is_retail:1
    }
  }else{
    subBody = {
      subscribed: localStorage.getItem("subscribed")
    }
  }

  const raw = JSON.stringify(subBody);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  fetch(`${heychic_api}/web/customer/subscribed`, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}
